/* ============================================================
   product-form.js
   - variant picker reactive
   - qty selector +/-
   - buy now (direct checkout)
   - inventory check
   - price update on variant change
   ============================================================ */

(function () {
  'use strict';

  /* ---------- Qty +/- ---------- */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-qty-btn]');
    if (!btn) return;
    const wrap = btn.closest('[data-qty]');
    if (!wrap) return;
    const input = wrap.querySelector('[data-qty-input]');
    if (!input) return;
    const dir = btn.dataset.qtyBtn;
    const current = parseInt(input.value, 10) || 1;
    const min = parseInt(input.min, 10) || 1;
    const max = parseInt(input.max, 10) || 999;
    let next = current;
    if (dir === 'inc') next = Math.min(max, current + 1);
    if (dir === 'dec') next = Math.max(min, current - 1);
    if (next !== current) {
      input.value = next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  /* ---------- Variant picker ---------- */
  document.querySelectorAll('[data-product-form]').forEach((form) => {
    const dataEl = form.querySelector('[data-product-json]');
    if (!dataEl) return;
    let productData;
    try { productData = JSON.parse(dataEl.textContent); } catch (e) { return; }
    const variants = productData.variants || [];
    if (!variants.length) return;

    const findVariant = () => {
      const selected = [...form.querySelectorAll('input[name^="options["]:checked')].map((i) => i.value);
      if (!selected.length) return variants[0];
      return variants.find((v) =>
        (v.options || []).every((opt, i) => opt === selected[i])
      );
    };

    const update = () => {
      const v = findVariant();
      if (!v) return;
      const idInput = form.querySelector('input[name="id"]');
      if (idInput) idInput.value = v.id;

      const priceWrap = form.querySelector('[data-variant-price]');
      if (priceWrap) {
        const cur = priceWrap.querySelector('.price__current');
        const cmp = priceWrap.querySelector('.price__compare');
        const badge = priceWrap.querySelector('.price__badge');
        if (cur) cur.textContent = formatMoney(v.price);
        if (v.compare_at_price && v.compare_at_price > v.price) {
          if (cmp) { cmp.textContent = formatMoney(v.compare_at_price); cmp.style.display = ''; }
          if (badge) {
            const pct = Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price);
            badge.textContent = '-' + pct + '%';
            badge.style.display = '';
          }
        } else {
          if (cmp) cmp.style.display = 'none';
          if (badge) badge.style.display = 'none';
        }
      }

      const submitBtn = form.querySelector('[data-product-submit]');
      const buyNowBtn = form.querySelector('[data-product-buynow]');
      const available = v.available;
      [submitBtn, buyNowBtn].forEach((btn) => {
        if (!btn) return;
        btn.disabled = !available;
        if (!available) {
          if (!btn.dataset._label) btn.dataset._label = btn.textContent.trim();
          btn.textContent = 'Agotado';
        } else if (btn.dataset._label) {
          btn.textContent = btn.dataset._label;
        }
      });

      const stockEl = form.querySelector('[data-stock-msg]');
      if (stockEl) {
        if (!available) {
          stockEl.textContent = 'Sin stock por ahora.';
          stockEl.classList.add('is-out');
        } else if (v.inventory_quantity != null && v.inventory_quantity > 0 && v.inventory_quantity < 10) {
          stockEl.textContent = 'Quedan ' + v.inventory_quantity + ' en stock.';
          stockEl.classList.remove('is-out');
        } else {
          stockEl.textContent = '';
          stockEl.classList.remove('is-out');
        }
      }
    };

    form.addEventListener('change', (e) => {
      if (e.target.matches('input[name^="options["]')) update();
    });
    update();
  });

  /* ---------- Buy now → direct checkout ---------- */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-product-buynow]');
    if (!btn) return;
    const form = btn.closest('form');
    if (!form) return;
    e.preventDefault();
    const id = form.querySelector('input[name="id"]').value;
    const qty = form.querySelector('input[name="quantity"]')?.value || 1;
    btn.disabled = true;
    const prev = btn.textContent;
    btn.textContent = 'Procesando…';

    const fd = new FormData();
    fd.append('id', id);
    fd.append('quantity', qty);

    fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
      .then((r) => r.ok ? r.json() : Promise.reject(r))
      .then(() => { window.location.href = '/checkout'; })
      .catch(() => {
        btn.disabled = false;
        btn.textContent = prev;
        if (window.HP_toast) window.HP_toast('No pudimos procesar la compra. Reintentá.');
      });
  });

  /* ---------- Helper money ---------- */
  function formatMoney(cents) {
    const v = (cents / 100).toLocaleString('es-UY', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    return '$' + v;
  }

})();
